import GLOBALS from "../Globals";

class ParseService {
  parse = GLOBALS.PARSE;

  Parse = (value) => {
    if (this.parse) return JSON.parse(value);
    else return value;
  };

  TransformToAWS = (value) => {
    var data = {};
    data.headers = { "Access-Control-Allow-Origin": "*" };
    data.body = JSON.stringify(value);
    return data;
  };
  TransformToBuyerTypeDTO = (buyerType, emplyoyeeId) => {
    var data = {};
    data.BuyerType = buyerType;
    data.EmployeeId = emplyoyeeId;
    return data;
  };
}

export default ParseService;
